import { useState } from 'react';
import { useAuthContext } from './useAuthContext';
import { toast } from 'react-hot-toast';

export const useLogin = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const { dispatch } = useAuthContext();

  const login = async (email, password) => {
    setIsLoading(true);
    setError(null);

    const toastId = toast.loading('Logging in...');
    const apiUrl = process.env.REACT_APP_API_URL || '';
    // Convert email to lowercase
    const formattedEmail = email.toLowerCase();

    const response = await fetch(`${apiUrl}/api/user/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: formattedEmail, password })
    });

    const json = await response.json();

    if (!response.ok) {
      setIsLoading(false);
      setError(json.error);
      toast.error(json.error, { id: toastId });
    }
    if (response.ok) {
      // Save the user to local storage
      localStorage.setItem('user', JSON.stringify(json));

      // Update the auth context
      dispatch({ type: 'LOGIN', payload: json });

      // Update loading state
      setIsLoading(false);
      toast.success('Login successful!', { id: toastId });
    }
  };

  return { login, isLoading, error };
};
